/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompleteScriptValidationRequest,
  CompleteScriptValidationResult,
  ContextScriptDTO,
  ContextScriptExportData,
  ContextScriptImportData,
  ContextScriptImportResult,
  ContextTransformationResult,
  ExecuteScriptByNameRequest,
  ExecuteScriptContentRequest,
  ExportScriptsParams,
  GetAllScriptsParams,
  GetScriptByNameParams,
  ImportScriptsParams,
  ScriptAnalytics,
  ScriptExecutionTestRequest,
  ScriptStatistics,
  ScriptSyntaxValidationRequest,
  ScriptTestResult,
  SearchScriptsParams,
  UpdateScriptStatusParams,
  ValidationResult
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getScriptById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptDTO>(
      {url: `/api/context-scripts/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetScriptByIdInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/context-scripts/${id}`
    ] as const;
    }

export const getGetScriptByIdQueryKey = (id?: string,) => {
    return [
    `/api/context-scripts/${id}`
    ] as const;
    }

    
export const getGetScriptByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getScriptById>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptByIdInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptById>>> = ({ signal }) => getScriptById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptById>>>
export type GetScriptByIdInfiniteQueryError = unknown


export function useGetScriptByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptById>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptById>>,
          TError,
          Awaited<ReturnType<typeof getScriptById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptById>>,
          TError,
          Awaited<ReturnType<typeof getScriptById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetScriptByIdQueryOptions = <TData = Awaited<ReturnType<typeof getScriptById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptById>>> = ({ signal }) => getScriptById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptById>>>
export type GetScriptByIdQueryError = unknown


export function useGetScriptById<TData = Awaited<ReturnType<typeof getScriptById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptById>>,
          TError,
          Awaited<ReturnType<typeof getScriptById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptById<TData = Awaited<ReturnType<typeof getScriptById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptById>>,
          TError,
          Awaited<ReturnType<typeof getScriptById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptById<TData = Awaited<ReturnType<typeof getScriptById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptById<TData = Awaited<ReturnType<typeof getScriptById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateScript = (
    id: string,
    contextScriptDTO: ContextScriptDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ContextScriptDTO>(
      {url: `/api/context-scripts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contextScriptDTO
    },
      options);
    }
  


export const getUpdateScriptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScript>>, TError,{id: string;data: ContextScriptDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScript>>, TError,{id: string;data: ContextScriptDTO}, TContext> => {

const mutationKey = ['updateScript'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScript>>, {id: string;data: ContextScriptDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateScript(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateScriptMutationResult = NonNullable<Awaited<ReturnType<typeof updateScript>>>
    export type UpdateScriptMutationBody = ContextScriptDTO
    export type UpdateScriptMutationError = unknown

    export const useUpdateScript = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScript>>, TError,{id: string;data: ContextScriptDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateScript>>,
        TError,
        {id: string;data: ContextScriptDTO},
        TContext
      > => {

      const mutationOptions = getUpdateScriptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteScript = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/context-scripts/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteScriptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScript>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteScript>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteScript'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScript>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteScript(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteScriptMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScript>>>
    
    export type DeleteScriptMutationError = unknown

    export const useDeleteScript = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScript>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteScript>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteScriptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllScripts = (
    params?: GetAllScriptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptDTO[]>(
      {url: `/api/context-scripts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllScriptsInfiniteQueryKey = (params?: GetAllScriptsParams,) => {
    return [
    'infinite', `/api/context-scripts`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllScriptsQueryKey = (params?: GetAllScriptsParams,) => {
    return [
    `/api/context-scripts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllScriptsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllScripts>>>, TError = unknown>(params?: GetAllScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllScriptsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllScripts>>> = ({ signal }) => getAllScripts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllScriptsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllScripts>>>
export type GetAllScriptsInfiniteQueryError = unknown


export function useGetAllScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllScripts>>>, TError = unknown>(
 params: undefined |  GetAllScriptsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllScripts>>,
          TError,
          Awaited<ReturnType<typeof getAllScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllScripts>>>, TError = unknown>(
 params?: GetAllScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllScripts>>,
          TError,
          Awaited<ReturnType<typeof getAllScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllScripts>>>, TError = unknown>(
 params?: GetAllScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllScripts>>>, TError = unknown>(
 params?: GetAllScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllScriptsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllScriptsQueryOptions = <TData = Awaited<ReturnType<typeof getAllScripts>>, TError = unknown>(params?: GetAllScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllScriptsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllScripts>>> = ({ signal }) => getAllScripts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllScriptsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllScripts>>>
export type GetAllScriptsQueryError = unknown


export function useGetAllScripts<TData = Awaited<ReturnType<typeof getAllScripts>>, TError = unknown>(
 params: undefined |  GetAllScriptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllScripts>>,
          TError,
          Awaited<ReturnType<typeof getAllScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllScripts<TData = Awaited<ReturnType<typeof getAllScripts>>, TError = unknown>(
 params?: GetAllScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllScripts>>,
          TError,
          Awaited<ReturnType<typeof getAllScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllScripts<TData = Awaited<ReturnType<typeof getAllScripts>>, TError = unknown>(
 params?: GetAllScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllScripts<TData = Awaited<ReturnType<typeof getAllScripts>>, TError = unknown>(
 params?: GetAllScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllScriptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createScript = (
    contextScriptDTO: ContextScriptDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptDTO>(
      {url: `/api/context-scripts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contextScriptDTO, signal
    },
      options);
    }
  


export const getCreateScriptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScript>>, TError,{data: ContextScriptDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createScript>>, TError,{data: ContextScriptDTO}, TContext> => {

const mutationKey = ['createScript'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScript>>, {data: ContextScriptDTO}> = (props) => {
          const {data} = props ?? {};

          return  createScript(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateScriptMutationResult = NonNullable<Awaited<ReturnType<typeof createScript>>>
    export type CreateScriptMutationBody = ContextScriptDTO
    export type CreateScriptMutationError = unknown

    export const useCreateScript = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScript>>, TError,{data: ContextScriptDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScript>>,
        TError,
        {data: ContextScriptDTO},
        TContext
      > => {

      const mutationOptions = getCreateScriptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const validateScriptSyntax = (
    scriptSyntaxValidationRequest: ScriptSyntaxValidationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ValidationResult>(
      {url: `/api/context-scripts/validate/syntax`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scriptSyntaxValidationRequest, signal
    },
      options);
    }
  


export const getValidateScriptSyntaxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateScriptSyntax>>, TError,{data: ScriptSyntaxValidationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateScriptSyntax>>, TError,{data: ScriptSyntaxValidationRequest}, TContext> => {

const mutationKey = ['validateScriptSyntax'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateScriptSyntax>>, {data: ScriptSyntaxValidationRequest}> = (props) => {
          const {data} = props ?? {};

          return  validateScriptSyntax(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateScriptSyntaxMutationResult = NonNullable<Awaited<ReturnType<typeof validateScriptSyntax>>>
    export type ValidateScriptSyntaxMutationBody = ScriptSyntaxValidationRequest
    export type ValidateScriptSyntaxMutationError = unknown

    export const useValidateScriptSyntax = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateScriptSyntax>>, TError,{data: ScriptSyntaxValidationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateScriptSyntax>>,
        TError,
        {data: ScriptSyntaxValidationRequest},
        TContext
      > => {

      const mutationOptions = getValidateScriptSyntaxMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const validateCompleteScript = (
    completeScriptValidationRequest: CompleteScriptValidationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompleteScriptValidationResult>(
      {url: `/api/context-scripts/validate/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeScriptValidationRequest, signal
    },
      options);
    }
  


export const getValidateCompleteScriptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateCompleteScript>>, TError,{data: CompleteScriptValidationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateCompleteScript>>, TError,{data: CompleteScriptValidationRequest}, TContext> => {

const mutationKey = ['validateCompleteScript'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateCompleteScript>>, {data: CompleteScriptValidationRequest}> = (props) => {
          const {data} = props ?? {};

          return  validateCompleteScript(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateCompleteScriptMutationResult = NonNullable<Awaited<ReturnType<typeof validateCompleteScript>>>
    export type ValidateCompleteScriptMutationBody = CompleteScriptValidationRequest
    export type ValidateCompleteScriptMutationError = unknown

    export const useValidateCompleteScript = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateCompleteScript>>, TError,{data: CompleteScriptValidationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateCompleteScript>>,
        TError,
        {data: CompleteScriptValidationRequest},
        TContext
      > => {

      const mutationOptions = getValidateCompleteScriptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const testScriptExecution = (
    scriptExecutionTestRequest: ScriptExecutionTestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScriptTestResult>(
      {url: `/api/context-scripts/test/execution`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scriptExecutionTestRequest, signal
    },
      options);
    }
  


export const getTestScriptExecutionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testScriptExecution>>, TError,{data: ScriptExecutionTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testScriptExecution>>, TError,{data: ScriptExecutionTestRequest}, TContext> => {

const mutationKey = ['testScriptExecution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testScriptExecution>>, {data: ScriptExecutionTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  testScriptExecution(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestScriptExecutionMutationResult = NonNullable<Awaited<ReturnType<typeof testScriptExecution>>>
    export type TestScriptExecutionMutationBody = ScriptExecutionTestRequest
    export type TestScriptExecutionMutationError = unknown

    export const useTestScriptExecution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testScriptExecution>>, TError,{data: ScriptExecutionTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testScriptExecution>>,
        TError,
        {data: ScriptExecutionTestRequest},
        TContext
      > => {

      const mutationOptions = getTestScriptExecutionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const importScripts = (
    contextScriptImportData: ContextScriptImportData,
    params?: ImportScriptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptImportResult>(
      {url: `/api/context-scripts/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contextScriptImportData,
        params, signal
    },
      options);
    }
  


export const getImportScriptsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importScripts>>, TError,{data: ContextScriptImportData;params?: ImportScriptsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importScripts>>, TError,{data: ContextScriptImportData;params?: ImportScriptsParams}, TContext> => {

const mutationKey = ['importScripts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importScripts>>, {data: ContextScriptImportData;params?: ImportScriptsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importScripts(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportScriptsMutationResult = NonNullable<Awaited<ReturnType<typeof importScripts>>>
    export type ImportScriptsMutationBody = ContextScriptImportData
    export type ImportScriptsMutationError = unknown

    export const useImportScripts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importScripts>>, TError,{data: ContextScriptImportData;params?: ImportScriptsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importScripts>>,
        TError,
        {data: ContextScriptImportData;params?: ImportScriptsParams},
        TContext
      > => {

      const mutationOptions = getImportScriptsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const executeScriptById = (
    id: string,
    executeScriptByIdBody: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextTransformationResult>(
      {url: `/api/context-scripts/execute/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeScriptByIdBody, signal
    },
      options);
    }
  


export const getExecuteScriptByIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeScriptById>>, TError,{id: string;data: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeScriptById>>, TError,{id: string;data: string}, TContext> => {

const mutationKey = ['executeScriptById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeScriptById>>, {id: string;data: string}> = (props) => {
          const {id,data} = props ?? {};

          return  executeScriptById(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteScriptByIdMutationResult = NonNullable<Awaited<ReturnType<typeof executeScriptById>>>
    export type ExecuteScriptByIdMutationBody = string
    export type ExecuteScriptByIdMutationError = unknown

    export const useExecuteScriptById = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeScriptById>>, TError,{id: string;data: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeScriptById>>,
        TError,
        {id: string;data: string},
        TContext
      > => {

      const mutationOptions = getExecuteScriptByIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const executeScriptContent = (
    executeScriptContentRequest: ExecuteScriptContentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextTransformationResult>(
      {url: `/api/context-scripts/execute/content`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeScriptContentRequest, signal
    },
      options);
    }
  


export const getExecuteScriptContentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeScriptContent>>, TError,{data: ExecuteScriptContentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeScriptContent>>, TError,{data: ExecuteScriptContentRequest}, TContext> => {

const mutationKey = ['executeScriptContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeScriptContent>>, {data: ExecuteScriptContentRequest}> = (props) => {
          const {data} = props ?? {};

          return  executeScriptContent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteScriptContentMutationResult = NonNullable<Awaited<ReturnType<typeof executeScriptContent>>>
    export type ExecuteScriptContentMutationBody = ExecuteScriptContentRequest
    export type ExecuteScriptContentMutationError = unknown

    export const useExecuteScriptContent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeScriptContent>>, TError,{data: ExecuteScriptContentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeScriptContent>>,
        TError,
        {data: ExecuteScriptContentRequest},
        TContext
      > => {

      const mutationOptions = getExecuteScriptContentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const executeScriptByName = (
    executeScriptByNameRequest: ExecuteScriptByNameRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextTransformationResult>(
      {url: `/api/context-scripts/execute/by-name`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeScriptByNameRequest, signal
    },
      options);
    }
  


export const getExecuteScriptByNameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeScriptByName>>, TError,{data: ExecuteScriptByNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeScriptByName>>, TError,{data: ExecuteScriptByNameRequest}, TContext> => {

const mutationKey = ['executeScriptByName'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeScriptByName>>, {data: ExecuteScriptByNameRequest}> = (props) => {
          const {data} = props ?? {};

          return  executeScriptByName(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteScriptByNameMutationResult = NonNullable<Awaited<ReturnType<typeof executeScriptByName>>>
    export type ExecuteScriptByNameMutationBody = ExecuteScriptByNameRequest
    export type ExecuteScriptByNameMutationError = unknown

    export const useExecuteScriptByName = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeScriptByName>>, TError,{data: ExecuteScriptByNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeScriptByName>>,
        TError,
        {data: ExecuteScriptByNameRequest},
        TContext
      > => {

      const mutationOptions = getExecuteScriptByNameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateScriptStatus = (
    id: string,
    params: UpdateScriptStatusParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ContextScriptDTO>(
      {url: `/api/context-scripts/${id}/status`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getUpdateScriptStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScriptStatus>>, TError,{id: string;params: UpdateScriptStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScriptStatus>>, TError,{id: string;params: UpdateScriptStatusParams}, TContext> => {

const mutationKey = ['updateScriptStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScriptStatus>>, {id: string;params: UpdateScriptStatusParams}> = (props) => {
          const {id,params} = props ?? {};

          return  updateScriptStatus(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateScriptStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateScriptStatus>>>
    
    export type UpdateScriptStatusMutationError = unknown

    export const useUpdateScriptStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScriptStatus>>, TError,{id: string;params: UpdateScriptStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateScriptStatus>>,
        TError,
        {id: string;params: UpdateScriptStatusParams},
        TContext
      > => {

      const mutationOptions = getUpdateScriptStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getScriptAnalytics = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScriptAnalytics>(
      {url: `/api/context-scripts/${id}/analytics`, method: 'GET', signal
    },
      options);
    }
  



export const getGetScriptAnalyticsInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/context-scripts/${id}/analytics`
    ] as const;
    }

export const getGetScriptAnalyticsQueryKey = (id?: string,) => {
    return [
    `/api/context-scripts/${id}/analytics`
    ] as const;
    }

    
export const getGetScriptAnalyticsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getScriptAnalytics>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptAnalyticsInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptAnalytics>>> = ({ signal }) => getScriptAnalytics(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptAnalyticsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptAnalytics>>>
export type GetScriptAnalyticsInfiniteQueryError = unknown


export function useGetScriptAnalyticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptAnalytics>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getScriptAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptAnalyticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptAnalytics>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getScriptAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptAnalyticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptAnalytics>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptAnalyticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptAnalytics>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptAnalyticsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetScriptAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getScriptAnalytics>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptAnalyticsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptAnalytics>>> = ({ signal }) => getScriptAnalytics(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptAnalytics>>>
export type GetScriptAnalyticsQueryError = unknown


export function useGetScriptAnalytics<TData = Awaited<ReturnType<typeof getScriptAnalytics>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getScriptAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptAnalytics<TData = Awaited<ReturnType<typeof getScriptAnalytics>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getScriptAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptAnalytics<TData = Awaited<ReturnType<typeof getScriptAnalytics>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptAnalytics<TData = Awaited<ReturnType<typeof getScriptAnalytics>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptAnalyticsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getScriptStatistics = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScriptStatistics>(
      {url: `/api/context-scripts/statistics`, method: 'GET', signal
    },
      options);
    }
  



export const getGetScriptStatisticsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/context-scripts/statistics`
    ] as const;
    }

export const getGetScriptStatisticsQueryKey = () => {
    return [
    `/api/context-scripts/statistics`
    ] as const;
    }

    
export const getGetScriptStatisticsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getScriptStatistics>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptStatisticsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptStatistics>>> = ({ signal }) => getScriptStatistics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptStatisticsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptStatistics>>>
export type GetScriptStatisticsInfiniteQueryError = unknown


export function useGetScriptStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptStatistics>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptStatistics>>,
          TError,
          Awaited<ReturnType<typeof getScriptStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptStatistics>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptStatistics>>,
          TError,
          Awaited<ReturnType<typeof getScriptStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptStatistics>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptStatisticsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptStatistics>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptStatisticsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetScriptStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getScriptStatistics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptStatistics>>> = ({ signal }) => getScriptStatistics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptStatistics>>>
export type GetScriptStatisticsQueryError = unknown


export function useGetScriptStatistics<TData = Awaited<ReturnType<typeof getScriptStatistics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptStatistics>>,
          TError,
          Awaited<ReturnType<typeof getScriptStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptStatistics<TData = Awaited<ReturnType<typeof getScriptStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptStatistics>>,
          TError,
          Awaited<ReturnType<typeof getScriptStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptStatistics<TData = Awaited<ReturnType<typeof getScriptStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptStatistics<TData = Awaited<ReturnType<typeof getScriptStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptStatisticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const searchScripts = (
    params: SearchScriptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptDTO[]>(
      {url: `/api/context-scripts/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchScriptsInfiniteQueryKey = (params?: SearchScriptsParams,) => {
    return [
    'infinite', `/api/context-scripts/search`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchScriptsQueryKey = (params?: SearchScriptsParams,) => {
    return [
    `/api/context-scripts/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchScriptsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchScripts>>>, TError = unknown>(params: SearchScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchScriptsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchScripts>>> = ({ signal }) => searchScripts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchScriptsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchScripts>>>
export type SearchScriptsInfiniteQueryError = unknown


export function useSearchScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchScripts>>>, TError = unknown>(
 params: SearchScriptsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchScripts>>,
          TError,
          Awaited<ReturnType<typeof searchScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchScripts>>>, TError = unknown>(
 params: SearchScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchScripts>>,
          TError,
          Awaited<ReturnType<typeof searchScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchScripts>>>, TError = unknown>(
 params: SearchScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchScripts>>>, TError = unknown>(
 params: SearchScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchScriptsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchScriptsQueryOptions = <TData = Awaited<ReturnType<typeof searchScripts>>, TError = unknown>(params: SearchScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchScriptsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchScripts>>> = ({ signal }) => searchScripts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchScriptsQueryResult = NonNullable<Awaited<ReturnType<typeof searchScripts>>>
export type SearchScriptsQueryError = unknown


export function useSearchScripts<TData = Awaited<ReturnType<typeof searchScripts>>, TError = unknown>(
 params: SearchScriptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchScripts>>,
          TError,
          Awaited<ReturnType<typeof searchScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchScripts<TData = Awaited<ReturnType<typeof searchScripts>>, TError = unknown>(
 params: SearchScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchScripts>>,
          TError,
          Awaited<ReturnType<typeof searchScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchScripts<TData = Awaited<ReturnType<typeof searchScripts>>, TError = unknown>(
 params: SearchScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchScripts<TData = Awaited<ReturnType<typeof searchScripts>>, TError = unknown>(
 params: SearchScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchScriptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const exportScripts = (
    params?: ExportScriptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptExportData>(
      {url: `/api/context-scripts/export`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExportScriptsInfiniteQueryKey = (params?: ExportScriptsParams,) => {
    return [
    'infinite', `/api/context-scripts/export`, ...(params ? [params]: [])
    ] as const;
    }

export const getExportScriptsQueryKey = (params?: ExportScriptsParams,) => {
    return [
    `/api/context-scripts/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExportScriptsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof exportScripts>>>, TError = unknown>(params?: ExportScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportScriptsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportScripts>>> = ({ signal }) => exportScripts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportScriptsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof exportScripts>>>
export type ExportScriptsInfiniteQueryError = unknown


export function useExportScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportScripts>>>, TError = unknown>(
 params: undefined |  ExportScriptsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportScripts>>,
          TError,
          Awaited<ReturnType<typeof exportScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportScripts>>>, TError = unknown>(
 params?: ExportScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportScripts>>,
          TError,
          Awaited<ReturnType<typeof exportScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportScripts>>>, TError = unknown>(
 params?: ExportScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportScriptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportScripts>>>, TError = unknown>(
 params?: ExportScriptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportScriptsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getExportScriptsQueryOptions = <TData = Awaited<ReturnType<typeof exportScripts>>, TError = unknown>(params?: ExportScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportScriptsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportScripts>>> = ({ signal }) => exportScripts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportScriptsQueryResult = NonNullable<Awaited<ReturnType<typeof exportScripts>>>
export type ExportScriptsQueryError = unknown


export function useExportScripts<TData = Awaited<ReturnType<typeof exportScripts>>, TError = unknown>(
 params: undefined |  ExportScriptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportScripts>>,
          TError,
          Awaited<ReturnType<typeof exportScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportScripts<TData = Awaited<ReturnType<typeof exportScripts>>, TError = unknown>(
 params?: ExportScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportScripts>>,
          TError,
          Awaited<ReturnType<typeof exportScripts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportScripts<TData = Awaited<ReturnType<typeof exportScripts>>, TError = unknown>(
 params?: ExportScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportScripts<TData = Awaited<ReturnType<typeof exportScripts>>, TError = unknown>(
 params?: ExportScriptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportScripts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportScriptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCategories = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/api/context-scripts/categories`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCategoriesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/context-scripts/categories`
    ] as const;
    }

export const getGetCategoriesQueryKey = () => {
    return [
    `/api/context-scripts/categories`
    ] as const;
    }

    
export const getGetCategoriesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoriesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategories>>> = ({ signal }) => getCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoriesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCategories>>>
export type GetCategoriesInfiniteQueryError = unknown


export function useGetCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoriesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategories>>> = ({ signal }) => getCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getCategories>>>
export type GetCategoriesQueryError = unknown


export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategories<TData = Awaited<ReturnType<typeof getCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getScriptByName = (
    params: GetScriptByNameParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextScriptDTO>(
      {url: `/api/context-scripts/by-name`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetScriptByNameInfiniteQueryKey = (params?: GetScriptByNameParams,) => {
    return [
    'infinite', `/api/context-scripts/by-name`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetScriptByNameQueryKey = (params?: GetScriptByNameParams,) => {
    return [
    `/api/context-scripts/by-name`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetScriptByNameInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getScriptByName>>>, TError = unknown>(params: GetScriptByNameParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptByNameInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptByName>>> = ({ signal }) => getScriptByName(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptByNameInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptByName>>>
export type GetScriptByNameInfiniteQueryError = unknown


export function useGetScriptByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptByName>>>, TError = unknown>(
 params: GetScriptByNameParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptByName>>,
          TError,
          Awaited<ReturnType<typeof getScriptByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptByName>>>, TError = unknown>(
 params: GetScriptByNameParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptByName>>,
          TError,
          Awaited<ReturnType<typeof getScriptByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptByName>>>, TError = unknown>(
 params: GetScriptByNameParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getScriptByName>>>, TError = unknown>(
 params: GetScriptByNameParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptByNameInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetScriptByNameQueryOptions = <TData = Awaited<ReturnType<typeof getScriptByName>>, TError = unknown>(params: GetScriptByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScriptByNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptByName>>> = ({ signal }) => getScriptByName(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetScriptByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getScriptByName>>>
export type GetScriptByNameQueryError = unknown


export function useGetScriptByName<TData = Awaited<ReturnType<typeof getScriptByName>>, TError = unknown>(
 params: GetScriptByNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptByName>>,
          TError,
          Awaited<ReturnType<typeof getScriptByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptByName<TData = Awaited<ReturnType<typeof getScriptByName>>, TError = unknown>(
 params: GetScriptByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScriptByName>>,
          TError,
          Awaited<ReturnType<typeof getScriptByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetScriptByName<TData = Awaited<ReturnType<typeof getScriptByName>>, TError = unknown>(
 params: GetScriptByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetScriptByName<TData = Awaited<ReturnType<typeof getScriptByName>>, TError = unknown>(
 params: GetScriptByNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScriptByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetScriptByNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




